import { render } from "./DrawResultIndex.vue?vue&type=template&id=9f2c4202&scoped=true"
import script from "./DrawResultIndex.vue?vue&type=script&lang=js"
export * from "./DrawResultIndex.vue?vue&type=script&lang=js"

import "./DrawResultIndex.vue?vue&type=style&index=0&id=9f2c4202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2c4202"]])

export default __exports__